import VueSnotify, { SnotifyPosition } from "vue-snotify";

let Notify = []

Notify.install = function(Vue) {
    Vue.use(VueSnotify, {
        toast: {
            position: SnotifyPosition.centerTop,
            timeout: 6000,
            closeOnClick: true,
            pauseOnHover: true,
            titleMaxLength: 30
        }
    })
    Vue.prototype.$notify = {

        success: (title,body) => {
            Vue.prototype.$snotify.success(body?body:'',title, {
                timeout: 2000
            })
        },

        error: (title,body) => {
            Vue.prototype.$snotify.error(body?body:'',title)
        },
    }
};

export default Notify;
